import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';

export default function* centrifugeUnsubscribe(action) {
  if (!window.centrifugeSubscriptions.length) {
    yield call(resolveActionPromise(action));
    return;
  }
  try {
    if (window?.centrifugeSubscriptions?.length) {
      for (let i = 0; i < window.centrifugeSubscriptions.length; i++) {
        const sub = window.centrifugeSubscriptions[i];
        try {
          const url = `${BACKEND_URL}/tracking/unsubscribe`;
          yield makeRequest(url, { chanel: sub.channel }, action, 'POST', true);
          sub.unsubscribe();
          sub.removeAllListeners();
        } catch (e) {
          window.logger.error(e);
        }
      }
    }
    window.centrifugeSubscriptions = [];
    yield call(resolveActionPromise(action));
  } catch (e) {
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
